import { render, staticRenderFns } from "./InventoryOnHand.vue?vue&type=template&id=3223ae7d&"
import script from "./InventoryOnHand.vue?vue&type=script&lang=js&"
export * from "./InventoryOnHand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports